import styled from 'styled-components';
import { Menu } from 'components/atoms/dropdown';
import { Tag } from 'components/atoms/tag';
import { Button as UnstyledButton } from 'components/facade/button';
import { ActionBar } from '../action-bar';
const FilterBarComponent = styled(ActionBar)`
  --action-bar-background: var(--white-100);
  margin: 0;
  padding: var(--spacing-03) var(--spacing-05);
  border-bottom: 1px solid var(--scarlet-gray-30);
  position: relative;
  z-index: var(--zindex-elevated);
  & ${Tag} {
    margin-left: var(--spacing-03);
  }
`;
const Button = styled(UnstyledButton).attrs({
    type: 'link',
    size: 'small'
})`
  margin-right: var(--spacing-03);

  &:last-child {
    margin-right: 0;
  }
`;
const Label = styled.span`
  font-weight: var(--font-weight-bold);
  padding: var(--spacing-02) var(--spacing-05);
  display: inline-block;
  margin-right: var(--spacing-03);

  &:last-child {
    margin-right: 0;
  }
`;
const FilterBar = FilterBarComponent;
FilterBar.Pill = Tag;
FilterBar.Menu = Menu;
FilterBar.Button = Button;
FilterBar.Label = Label;
export { FilterBar };
